import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      role: "",
      user: null, // { name, email, avatar, firstName, lastName, businessName, etc. }
      vendorStatus: "",

      setAuth: ({ token, role, user }) =>
        set({
          token,
          role,
          user,
        }),

      updateUser: (userData) =>
        set((state) => ({
          user: { ...state.user, ...userData },
        })),

      logout: () =>
        set({
          token: null,
          role: "",
          user: null,
          vendorStatus: "",
        }),

      setVendorStatus: (status) =>
        set({
          vendorStatus: status,
        }),

      // Helper getter
      isAuthenticated: () => !!get().token,
    }),
    {
      name: "auth-storage",
    }
  )
);
